import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HhsgSharedFooterComponent } from './components/footer/footer.component';
import { HhsgSharedHeaderModule } from './components/header/header.module';
import { HhsgSharedSidenavBarComponent } from './components/sidenav-bar/sidenav-bar.component';
import { HhsgSharedBuildTimeVariables } from './models/build-time-variables.model';
import { HhsgSharedConfigService } from './services/config.service';
import { HhsgSharedHttpService } from './services/http.service';
import { HhsgSharedNavHeaderService } from './services/nav-header.service';
import { HhsgSharedMockProfileService, HhsgSharedProfileService } from './services/profile.service';
import { HhsgSharedSubNavService } from './services/sub-nav.service';
import { HhsgSharedUserService } from './services/user.service';
import { HhsgSharedLoadingService } from './services/loading.service';
import {
  HhsgSharedApplicationsService,
  HhsgSharedAspDataStoreService,
  HhsgSharedClientAdminService,
  HhsgSharedCorporationService,
  HhsgSharedFormStateService,
  HhsgSharedStuderApplicationService,
  HhsgSharedStuderDepartmentService,
  HhsgSharedStuderDivisionService,
  HhsgSharedStuderEmployeeService,
  HhsgSharedStuderFacilityService,
  HhsgSharedStuderJobTitleService,
  HhsgSharedStuderOrganizationService,
  HhsgSharedStuderService,
  HhsgSharedStuderSupportContactService,
  HhsgSharedTabControlService,
  HhsgSharedUserAdministratorService,
  HhsgSharedUserAdminService
} from './services';
import { HhsgSharedHttpInterceptor } from './services/http.interceptor';
import { HhsgSharedAdminModule } from './components/admin/admin.module';
import { HhsgSharedQuicksightService } from './services/quicksight.service';
import { HhsgSharedCommonModule, HhsgSharedDevExtremeModule } from './components';
import { HhsgSharedReportingModule } from './components/reporting/reporting.module';
import { HhsgSharedNotificationService } from './services/notification-service';
import { MaterialDesignModule } from './material-design/material-design.module';
import { DxButtonModule, DxCheckBoxModule, DxDateBoxModule, DxFormModule, DxListModule, DxSelectBoxModule, DxTextAreaModule, DxTooltipModule } from 'devextreme-angular';
import { HhsgSharedUserProfileService } from './services/user-profile.service';
import { HhsgUserIdleService } from './services/user-idle.service';
import { HhsgSharedAdminService } from './services/admin.service';
import { HhsgSharedImporterService } from './services/importer.service';

export function configServiceFactory(config: HhsgSharedConfigService, url: string) {
  const result = () => config.load(url);
  return result;
}

export function profileServiceFactory(
  httpService: HhsgSharedHttpService,
  configService: HhsgSharedConfigService,
  buildVars: HhsgSharedBuildTimeVariables
) {
  if (buildVars.enableMock) {
    return new HhsgSharedMockProfileService(buildVars.mockUser);
  } else {
    return new HhsgSharedProfileService(httpService, configService);
  }
}

@NgModule({
  declarations: [
    HhsgSharedFooterComponent,
    HhsgSharedSidenavBarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    HttpClientModule,
    HhsgSharedAdminModule,
    HhsgSharedCommonModule,
    HhsgSharedHeaderModule,
    HhsgSharedReportingModule,
    HhsgSharedDevExtremeModule,
	  MaterialDesignModule,
    RouterModule
  ],
  exports: [
    HhsgSharedHeaderModule,
    HhsgSharedFooterComponent,
    HhsgSharedSidenavBarComponent,
    HhsgSharedDevExtremeModule
  ]
})
export class HHSGSharedComponentsModule {
  static forRoot(configUrl: string, buildVars: HhsgSharedBuildTimeVariables, ignoreDefaultOidcSetup?: boolean): ModuleWithProviders<HHSGSharedComponentsModule> {
    return {
      ngModule: HHSGSharedComponentsModule,
      providers: [
        HhsgSharedApplicationsService,
        HhsgSharedAspDataStoreService,
        HhsgSharedClientAdminService,
        HhsgSharedConfigService,
        HhsgSharedCorporationService,
        HhsgSharedFormStateService,
        HhsgSharedHttpService,
        HhsgSharedLoadingService,
        HhsgSharedNavHeaderService,
        HhsgSharedQuicksightService,
        HhsgSharedStuderApplicationService,
        HhsgSharedStuderDepartmentService,
        HhsgSharedStuderDivisionService,
        HhsgSharedStuderEmployeeService,
        HhsgSharedStuderFacilityService,
        HhsgSharedStuderJobTitleService,
        HhsgSharedStuderOrganizationService,
        HhsgSharedStuderService,
        HhsgSharedStuderSupportContactService,
        HhsgSharedSubNavService,
        HhsgSharedTabControlService,
        HhsgSharedUserAdministratorService,
        HhsgSharedUserAdminService,
        HhsgSharedUserProfileService,
        HhsgSharedUserService,
        HhsgSharedNotificationService,
        HhsgUserIdleService,
        HhsgSharedImporterService,
        HhsgSharedAdminService,
        { provide: 'ConfigUrl', useValue: configUrl },
        { provide: 'BuildVars', useValue: buildVars },
        {
          provide: APP_INITIALIZER,
          useFactory: configServiceFactory,
          deps: [HhsgSharedConfigService, 'ConfigUrl'],
          multi: true
        },
        {
          provide: HhsgSharedProfileService,
          useFactory: profileServiceFactory,
          deps: [HhsgSharedHttpService, HhsgSharedConfigService, 'BuildVars']
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HhsgSharedHttpInterceptor,
          multi: true
        }
      ]
    };
  }
}
